import { IDelegationServiceMock } from "./delegation.types";

export const mockDelegationService = (): IDelegationServiceMock => ({
  getDelegations: jest.fn(),
  getDelegationsByCountry: jest.fn(),
});
